import { JourneyFeatureFlags } from '@epilot/journey-logic-commons'
import { useEffect } from 'react'
import { useThrottledCallback } from 'use-debounce'

import { useJourneyContext } from '../blocks-renderers/providers/JourneyContext'
import { contextualValuesChanged } from '../store/actions/contextualValuesChanged'
import { historyStackChanged } from '../store/actions/historyStackChanged'
import { syncStepsState } from '../store/actions/syncStepsState'

import { useFlag } from './useFlags'

/**
 * Responsible for syncing state from Journey context to the Store.
 *
 * @deprecated to be removed when state management is fully migrated to the store
 */
export const useSyncAppStore = () => {
  const { context } = useJourneyContext()
  const newEngineEnabled = useFlag(JourneyFeatureFlags.LOGICS_ENGINE)

  const throttledSyncStepsState = useThrottledCallback(syncStepsState, 100, {
    leading: false,
    trailing: true
  })

  useEffect(
    // sync step
    () =>
      void throttledSyncStepsState({ stepsState: context._stepsStateArray }),
    [throttledSyncStepsState, context._stepsStateArray]
  )

  useEffect(
    () =>
      // sync contextual values
      void contextualValuesChanged({
        contextualValues: context._contextParams
      }),
    [context._contextParams]
  )

  useEffect(
    // sync history stack for progress bar purposes
    () => {
      if (!newEngineEnabled) {
        historyStackChanged({ stack: context._navigationInfo.stack })
      }
    },
    [newEngineEnabled, context._navigationInfo.stack]
  )
}
